import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0 pb-4" }
const _hoisted_3 = { class: "default-table-area style-two team-members" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }
const _hoisted_6 = { class: "border-0 py-4 pb-0" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex-grow-1 ms-2 position-relative top-2" }
const _hoisted_11 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_12 = { class: "fs-12" }
const _hoisted_13 = { class: "border-0 py-3 pb-0" }
const _hoisted_14 = { class: "border-0 py-3 pb-0" }
const _hoisted_15 = ["aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-4\" data-v-240479fb><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\" data-v-240479fb><h3 class=\"mb-0\" data-v-240479fb>Team Members</h3><div class=\"dropdown action-opt\" data-v-240479fb><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-240479fb><i data-feather=\"more-horizontal\" data-v-240479fb></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-240479fb><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"clock\" data-v-240479fb></i> Today </a></li><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"pie-chart\" data-v-240479fb></i> Last 7 Days </a></li><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"rotate-cw\" data-v-240479fb></i> Last Month </a></li><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"calendar\" data-v-240479fb></i> Last 1 Year </a></li><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"bar-chart\" data-v-240479fb></i> All Time </a></li><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"eye\" data-v-240479fb></i> View </a></li><li data-v-240479fb><a class=\"dropdown-item\" href=\"javascript:;\" data-v-240479fb><i data-feather=\"trash\" data-v-240479fb></i> Delete </a></li></ul></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Name"),
                _createElementVNode("th", { scope: "col" }, "Tasks"),
                _createElementVNode("th", { scope: "col" }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.slice(0, 5), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: item.user.image,
                          class: "wh-44 rounded-circle",
                          alt: "user"
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h6", _hoisted_11, _toDisplayString(item.user.name), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(item.user.email), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.tasks), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['progress bg-opacity-10', item.status.class]),
                      role: "progressbar",
                      "aria-label": "Example with label",
                      "aria-valuenow": item.status.percentage,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                      style: {"height":"5px"}
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['progress-bar rounded-pill', item.status.class]),
                        style: _normalizeStyle({
                        width: item.status.percentage + '%',
                        height: '5px',
                      })
                      }, null, 6)
                    ], 10, _hoisted_15)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}